import request from "./request";

export const getUserInfo = () => {
  return request({
    url: "/user/getUserInfo",
  });
};
export const getCaptchaAuth = () => {
  return request({
    url: "/user/getCaptcha",
  });
};

// 特殊逻辑的获取登录二维码
export const getLoginQRCode = (params) => {
  return request({
    url: "/weChat/getLoginQRCode",
    method: "get",
    params,
  });
};

export const loopWxFollow = (params) => {
  return request({
    url: "/weChat/public/loginByScene",
    method: "get",
    params,
  });
};

export const getStatus = () => {
  return request({
    url: "/user/student/getStatus",
  });
};

// 绑定手机发送验证码
export const bindSendCode = (params) => {
  return request({
    url: "/weChat/public/sendCode",
    params,
  });
};

export const updatePwd = (data = {}) => {
  return request({
    url: "/user/updatePassword",
    method: "post",
    data,
  });
};

// 登录发送验证码
export const sendCode = (params) => {
  return request({
    url: "/user/sendCode",
    params,
  });
};

export const logout = (params) => {
  return request({
    url: "/user/logout",
    params,
  });
};

// 绑定手机
export const bindPhone = (data) => {
  return request({
    url: "/weChat/sms/public/login",
    data,
    method: "post",
    showLoading: true,
  });
};

// 短息验证码登录
export const login = (data) => {
  return request({
    url: "/weChat/sms/login",
    data,
    method: "post",
    showLoading: true,
  });
};

// PC短信验证码登录
export const loginPc = (data) => {
  return request({
    url: "/user/student/sms/login",
    data,
    method: "post",
  });
};

// 账号密码登录
export const login2 = (data) => {
  return request({
    url: "/user/student/password/login",
    data,
    method: "post",
  });
};

// 没有密码的情况下设置密码
export const initPassword = (data) => {
  return request({
    url: "/user/newUpdatePassword",
    method: "post",
    data,
  });
};

// 微信授权登录
export const wechatLogin = (data) => {
  return request({
    url: "/weChat/public/login",
    data,
    method: "post",
    showLoading: true,
  });
};

// 平台微信授权登录
export const platformWechatLogin = (data) => {
  return request({
    url: "/weChat/platform/public/login",
    data,
    method: "post",
    showLoading: true,
  });
};

// 大会微信授权登录
export const meetformWechatLogin = (data) => {
  return request({
    url: "/weChat/liveMeeting/public/login",
    data,
    method: "post",
    showLoading: true,
  });
};

// 大会官网微信授权登录
export const meetingWebWechatLogin = (data) => {
  return request({
    url: "/conference/user/public/login",
    data,
    method: "post",
    showLoading: true,
  });
};
// 认证记录
export const renzhengList = () => {
  return request({
    url: "/user/apply/student/list",
    showLoading: true,
  });
};

// 科室
export const getDepementList = () => {
  return request({
    url: "/department/list",
  });
};

// 职称
export const getTitleList = () => {
  return request({
    url: "/title/list",
  });
};

// 学员认证申请信息  0-未申请; 1-待通过; 2-未通过; 3-已通过
export const getUserApply = () => {
  return request({
    url: "/user/apply/student/getUserApply",
    showLoading: true,
  });
};

// 新增学员认证申请
export const addApply = (data) => {
  return request({
    url: "/user/apply/student/add",
    data,
    method: "post",
    showLoading: true,
  });
};

// 重新认证
export const updateApply = (data) => {
  return request({
    url: "/user/apply/student/update",
    data,
    method: "post",
    showLoading: true,
  });
};

// 根据学科ID查询项目申请信息
export const bySubjectId = (params) => {
  return request({
    url: "/apply/project/bySubjectId",
    params,
  });
};

// 获取验证码
export const sendCodeToUpdatePhone = (params) => {
  return request({
    url: "/weChat/public/sendCodeToUpdatePhone",
    params,
  });
};

// 更换手机号
export const updateUserPhone = (data) => {
  return request({
    url: "/weChat/updateUserPhone",
    data,
    method: "post",
    showLoading: true,
  });
};

// 获取我的证书
export const getUserCertificateList = (params) => {
  return request({
    url: "/certificate/getUserCertificateList",
    params,
  });
};

// 儿科登录
export const mhlpLogin = (data) => {
  return request({
    url: "/weChat/public/code/login",
    data,
    method: "post",
    showLoading: true,
  });
};

// 儿科绑定手机号
export const mhlpBindPhone = (data) => {
  return request({
    url: "/weChat/sms/public/bind/login",
    data,
    method: "post",
    showLoading: true,
  });
};

//根据标签名称获取专家
export const getExpertListByTagName = (params = {}) => {
  return request({
    url: "/user/getExpertListByTagName",
    method: "get",
    params,
  });
};

// 专家详情
export const expertAllDetail = (params) => {
  return request({
    url: `/user/expert/detail`,
    method: "get",
    params,
  });
};

// 根据标签获取课程-可搜索
export const getSearchActivity = (params) => {
  return request({
    url: `/special/level2/list`,
    method: "get",
    params,
  });
};

// 根据标签获取课程
export const getActivity = (params) => {
  return request({
    url: `/special/level2/list?tagName=${params}`,
    method: "get",
  });
};

//是否显示补充信息
export const getStudentNeedMember = (params) => {
  return request({
    url: "/user/student/getStudentNeedMember",
    method: "get",
    params,
  });
};

// 完善个人信息
export const memberInfo = (data) => {
  return request({
    url: "/user/student/update/member/info",
    data,
    method: "post",
  });
};

// 查询订阅记录
export const subscribeUser = (params) => {
  return request({
    url: "/collection/subscribeUser",
    method: "get",
    params,
  });
};

// 取消订阅
export const cancelSubscribe = (data) => {
  return request({
    url: "/collection/cancelSubscribe",
    method: "post",
    data,
  });
};
// 判断是否新儿科用户（非基地儿科学员）
export const isNewMhlpStu = (params) => {
  return request({
    url: "/user/mhlp/queryOrAddStudentByPhone",
    params,
    method: "get",
  });
};

// 获取banner列表
export const getBannerList = (params) => {
  return request({
    url: `/banner/frontList`,
    method: "get",
    params,
  });
};

// 我的成就列表
export const badgeList = (params) => {
  return request({
    url: `/middle/badge/my/list`,
    method: "get",
    params,
  });
};

// 徽章等级列表
export const badgeLevelList = (params) => {
  return request({
    url: `/middle/badge/level/list`,
    method: "get",
    params,
  });
};

// 生成一次性CODE绑定TOKEN
export const tokenGetCode = (params) => {
  return request({
    headers: {
      "Cache-Control": "no-cache",
    },
    url: `/user/generate/code`,
    method: "get",
    params,
    showLoading: true,
  });
};

// 消费CODE换取TOKEN
export const codeExchangeToken = (params) => {
  return request({
    url: `/user/codeExchangeToken`,
    method: "get",
    params,
    showLoading: true,
  });
};

// 添加用户网页浏览记录
export const addPageBrowserRecord = (data) => {
  return request({
    url: "/user/addPageBrowserRecord",
    method: "post",
    data,
  });
};

// 获取培训平台首页相关配置
export const getPlatformConfig = (params) => {
  return request({
    url: "/platform/index/config",
    method: "get",
    params,
  });
};

// 是否可以跳儿科
export const queryButton = (params) => {
  return request({
    url: "/mlhp/user/queryButton",
    method: "get",
    params,
  });
};
// 微信授权登录（eye）
export const eyeWechatLogin = (data) => {
  return request({
    url: "/weChat/eye/public/code/login",
    method: "post",
    data,
  });
};

// 大会用code获取appid
export const weChatAuthorization = (data) => {
  return request({
    url: "/conference/user/public/weChatAuthorization",
    method: "post",
    data,
  });
};
